import React from 'react'
import AuthorImg from '../../static/author/author.png';
import DummyAuthor from "../../static/author/dummy-profile.jpg";
import { Link } from 'gatsby'

const Author = () => {
    return (
        <>
            <section className="upper-main-author" id="main-upper-author">
                <div className="grid-two-columns">

                    <div className="grid-child" id="author-contents">

                    <p>
                        
My interest in writing began when I had an excellent high school English Teacher. Diagramming sentences  was like solving mysteries. 
                        </p>                        
        
                        <h1 className="author-name-tag">
                            <span>Doris Howe</span>
                        </h1>

                        <span className="author-tagline">
                            Author & Writer
                        </span>

                        <button >
                            <Link to="/about-the-author">Read More</Link>
                        </button>
                    </div>
                    
                    <div className="grid-child" id="author-image-container">
                        <img alt="author-img" src={AuthorImg}/>
                    </div>

                    <div className="grid-child" id="author-image-container">
                        <img alt="author-img" src={DummyAuthor} hidden/>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Author;